import { setCookie, getCookie } from '../functions';

export default class OrangeCookie {
    constructor(_elm) {
        this.cookieConsentEl = _elm;
        this.cookieToggleEl = document.querySelector('.OrangeCookie-toggleButton');

        this.cookieAcceptButton = document.getElementById('acceptselectedcookies');
        this.cookieAcceptAllButton = document.getElementById('acceptallcookies');

        this.cookieCheckboxes = document.getElementsByName('cookieChoice');

        this.cookieItemToggleButtons = document.querySelectorAll('.OrangeCookie-item-group-toggleButton');

        this.ALLCOOKIESVALUE = 'allcookies';
        this.NOCOOKIESVALUE = 'nocookies';

        this.cookieInit();
        this.setEventListeners();
    }

    async cookieInit() {
        if (typeof window.dataLayer === 'undefined') window.dataLayer = [];

        if (!this.cookieConsentEl || this.cookieCheckboxes.length === 0) {
            if (this.cookieToggleEl) {
                this.cookieToggleEl.classList.toggle('close');
            }
            return;
        }

        this.cookieConsent = await getCookie('occ');

        if (this.cookieConsent) {
            if (this.cookieConsent === this.ALLCOOKIESVALUE) {
                for (let i = 0; i < this.cookieCheckboxes.length; i++) {
                    this.cookieCheckboxes[i].checked = true;
                    this.cookieCheckboxes[i].closest('.OrangeCookie-item-group').classList.add('selected');
                }
            }
            if (this.cookieConsent !== (this.ALLCOOKIESVALUE || this.NOCOOKIESVALUE)) {
                for (let i = 0; i < this.cookieCheckboxes.length; i++) {
                    if (this.cookieConsent.indexOf(this.cookieCheckboxes[i].value) !== -1) {
                        this.cookieCheckboxes[i].checked = true;
                        this.cookieCheckboxes[i].closest('.OrangeCookie-item-group').classList.add('selected');
                    }
                }
            }
        } else {
            this.toggleCookieConsentEl();
        }
    }

    setEventListeners() {
        if (this.cookieAcceptButton) {
            this.cookieAcceptButton.addEventListener('click', () => {
                let cookieValueString = '';
                let cookievalueArray = [];

                for (let i = 0; i < this.cookieCheckboxes.length; i++) {
                    if (this.cookieCheckboxes[i].checked) {
                        cookievalueArray.push(this.cookieCheckboxes[i].value);
                    }
                }

                if (cookievalueArray.length === this.cookieCheckboxes.length) cookieValueString = this.ALLCOOKIESVALUE;
                if (cookievalueArray.length === 0) cookieValueString = this.NOCOOKIESVALUE;

                let cookieValue = cookieValueString ? cookieValueString : cookievalueArray;

                setCookie('occ', cookieValue, 180);
                this.toggleCookieConsentEl();
            });
        }

        if (this.cookieAcceptAllButton) {
            this.cookieAcceptAllButton.addEventListener('click', () => {
                for (let i = 0; i < this.cookieCheckboxes.length; i++) {
                    this.cookieCheckboxes[i].checked = true;
                    this.cookieCheckboxes[i].closest('.OrangeCookie-item-group').classList.add('selected');
                }
                setCookie('occ', this.ALLCOOKIESVALUE, 180);
                this.toggleCookieConsentEl();
            });
        }

        if (this.cookieToggleEl) {
            this.cookieToggleEl.addEventListener('click', () => {
                this.toggleCookieConsentEl();
            });
        }

        if (this.cookieCheckboxes.length) {
            this.cookieCheckboxes.forEach((checkboxEl) => {
                checkboxEl.addEventListener('change', () => {
                    checkboxEl.closest('.OrangeCookie-item-group').classList.toggle('selected');
                });
            });
        }

        if (this.cookieItemToggleButtons.length) {
            this.cookieItemToggleButtons.forEach((toggleButtonEl) => {
                toggleButtonEl.addEventListener('click', () => {
                    toggleButtonEl.closest('.OrangeCookie-item').classList.toggle('open');
                    let contentQuerySelector = '.OrangeCookie-item-content-' + toggleButtonEl.dataset.name;
                    document.querySelector(contentQuerySelector).classList.toggle('open');
                });
            });
        }
    }

    toggleCookieConsentEl() {
        this.cookieConsentEl.classList.toggle('close');
        this.cookieToggleEl.classList.toggle('close');
    }
}
